import React from 'react';
import { Link } from 'react-router-dom';

const style = {
  flex: 1,
  textAlign: 'center' as 'center',
  margin: '0.25em',
  padding: '0.25em',
  border: '1px solid #ddd',
  textDecoration: 'none',
  listStyle: 'none',
};

interface iLinks {
  name: string;
  to: string;
}

interface LinkProps {
  links: iLinks[];
}

function isExternalLink(link: string) {
  return link.includes('http');
}

function LinkLabel(name: string) {
  return (
    <label
      title={name}
      style={{ color: '#1d4589', textDecoration: 'none', cursor: 'pointer' }}
    >
      {name}
    </label>
  );
}

function LinkHref({ name, to }: { name: string; to: string }) {
  return isExternalLink(to) ? (
    <a href={to} target='_blank' rel='noopener noreferrer' style={style}>
      {LinkLabel(name)}
    </a>
  ) : (
    <Link key={name} style={{ ...style }} to={to}>
      {LinkLabel(name)}
    </Link>
  );
}

export default function Header({ links }: LinkProps) {
  return (
    <nav
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <ul>
        {links.map((link: iLinks) =>
          LinkHref({ name: link.name, to: link.to })
        )}
      </ul>
    </nav>
  );
}
